export enum TemplateTransportType {
  EMAIL = 'email',
  IGDM = 'igdm',
}
